import React, { useState, useEffect } from "react";
import LoadingWheel from "./LoadingWheel";

const WEB_DISPLAY_URLS = ["/", "/collections"];

const OptimisedImage = ({
  src,
  className,
  style,
  alt,
  id,
  width,
  height,
  isLCP = false,
}) => {
  const baseSrc = src
    .replace(/\.[^/.]+$/, "")
    .replace("/img/", "/img_optimised/");

  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const currentUrl = window.location.href;
    // console.log("Current URL:", currentUrl);
    const isHomepage =
      window.location.pathname === "/" || window.location.pathname === "";
    // console.log("Is homepage:", isHomepage);

    if (isHomepage) {
      const checkImage = async () => {
        setLoading(true);
        if (await imageExists(`${baseSrc}.webp`)) {
          setImageUrl(`${baseSrc}.webp`);
        } else {
          setLoading(false);
          setImageUrl(src);
        }
      };

      checkImage();
    } else {
      setLoading(false);
      setImageUrl(src);
    }
  }, [src]);

  const handleImageLoad = () => setLoading(false);

  const imageExists = (url) => {
    return new Promise((resolve) => {
      const img = new window.Image();
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = url;
    });
  };

  return (
    <>
      {loading && <LoadingWheel />}

      <img
        src={imageUrl}
        // loading={isLCP ? "eager" : "lazy"}
        // fetchpriority={isLCP ? "high" : undefined}
        // decoding="async"
        onLoad={handleImageLoad}
        style={loading ? { visibility: "hidden", ...style } : style}
        {...(id && { id })}
        {...(className && { className })}
        {...(alt && { alt })}
        {...(width && { width })}
        {...(height && { height })}
      />
    </>
  );
};

export default OptimisedImage;
